import { COLORS } from 'helpers/globals'
import { column } from 'helpers/styles/grid'

export const button = {
  padding: '0 .5rem',
  borderRadius: '.4rem',
  color: 'white',
  fontSize: '1.2rem',
  fontWeight: 'bold',
  cursor: 'pointer',
  background: COLORS.primary,
  '&:hover': { background: '#2972B1' }
}

export default {
  details: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`
  },
  container: {
    padding: '.8rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  goBackButton: {
    marginRight: 7
  },
  destroyButton: {
    color: 'red',
    fontSize: '1.9rem',
    float: 'right',
    marginRight: '1rem'
  },
  actions: {
    marginLeft: '1.5rem',
    fontSize: '2rem',
    flexShrink: 0,
    '& a:not(:last-of-type)': { marginRight: '1rem' }
  },
  label: {
    lineHeight: '3.5rem',
    ...column,
    padding: '0!important',
    marginRight: '0!important',
    color: 'black',
    flex: '0 0 15%',
    maxWidth: '15%'
  },
  colorLabel: {
    color: 'black',
    width: '5rem',
    flexShrink: 0
  },
  otherLabel: {
    color: 'black',
    flexShrink: 0,
    width: '11rem'
  },
  configureButton: button,
  addDoorButton: {
    ...button,
    background: COLORS.green,
    '&:hover': { background: '#007800' }
  },
  input: {
    flex: '0 0 55%'
  },
  doorList: {
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    padding: '0 .8rem .8rem .8rem'
  },
  doorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  door: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 1rem',
    '&:nth-of-type(odd)': {
      background: COLORS.tertiary
    }
  },
  distanceText: {
    fontSize: '1.2rem',
    display: 'block'
  },
  distanceTextFadeIn: {
    visibility: 'visible',
    opacity: 1,
    transition: 'visibility 0s linear 0s, opacity 200ms linear'
  },
  distanceTextFadeOut: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s linear 200ms, opacity 200ms linear'
  },
  doorIcon: {
    borderRadius: '50%',
    color: 'white',
    flex: '0 1 3rem',
    height: '3rem',
    display: 'flex',
    marginRight: '1rem'
  },
  expansionList: {
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    padding: '0 .8rem'
  },
  expansionButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 .8rem .8rem .8rem'
  },
  expansionButton: {
    padding: '.3rem 1rem',
    borderRadius: '1rem',
    color: 'white',
    fontWeight: 400,
    cursor: 'pointer',
    background: COLORS.primary,
    '&:hover': { background: '#2972B1' }
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerDetails/style.js